import React from "react";
import { Router, Location } from "@reach/router";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { fetchDataFile } from "../components/Fetch";
import ReactHtmlParser from "react-html-parser";
import NavLink from "../components/NavLink";
import LeftColumn from "./columns/LeftColumn";
import RightColumn from "./columns/RightColumn";
import Footer from "./elements/Footer";
import Sheet from './Sheet';

import TT from '../containers/svg/TT';
import TTLegend from '../containers/svg/TTLegend';
import {I18nContext } from '../containers/i18n/I18nProvider';
import {translate} from '../containers/i18n';

import "../styles/technique.css";

class Technique extends React.Component {

  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.setSheetId = this.setSheetId.bind(this);

    this.state = {
      sheetId: undefined,
      htmlContent: null
    };
  }

  componentDidMount() {
    fetchDataFile(this.props.url, "", this.onLoadComplete);
  }

  setSheetId(id) {
    this.setState({sheetId: id});
  }

  updateContainerHeight(h) {
    const mc = document.getElementById("mainContainer");
    if (mc) mc.style.height = h + 192 + "px";
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page });
  }

  updateContent(content) {
    const d = document.getElementById("mainContainer");

    if (d) {
      const h = content ? d.clientHeight + 512 : 1000;
      return h;
    } else {
      setTimeout(this.updateContent, 250);
    }
  }

  render() {
    const content = this.state.htmlContent;
    const h = this.updateContent(content);
    const n = parseInt(h / 768);

    const cp = document.getElementById("cp");
    const s = cp ? { height: cp.clientHeight } : { height: "100%" };
    if (this.props.setFooterPosition) this.props.setFooterPosition(s);

    return (
      <>
        <div id="mainContainer" className="mainContainer">
          <LeftColumn page="technique" n={n}/>
          <RightColumn page="technique" n={n}/>
          <div id="cp" className="page technique">   
          <FadeTransitionRouter
              updateState={this.updateState}
              currentSheetId={this.state.sheetId}
            >
              <Sheet
                path="/"
                menu={this.props.menu}
                updateContainerHeight={this.updateContainerHeight}
                setSheetId={this.setSheetId}
                lang={this.context.lang}
              />
              <Sheet
                path="sheet/:sheetId"
                updateContainerHeight={this.updateContainerHeight}
                setSheetId={this.setSheetId}
                lang={this.context.lang}
              />
            </FadeTransitionRouter>      
            {!this.state.sheetId && <>
              {content}
              <div className="imgTT">
                <span className="">{this.props.t("tt_legend0")}</span>
                <div className="imgTT1"><TT/></div>
                <div className="imgTT2"><TTLegend t={this.props.t}/></div>
              </div>
              {
                this.renderMenu()
              }
              </>              
            }
          </div>
        </div>
          {!this.state.sheetId && <Footer />}
      </>
    );
  }

  renderMenu() {
    if (this.state.sheetId) return <div/>;

    const menuP = this.props.menu.subMenu || [];
    return (
      <div className="menu">
          <hr className="stars"/>
          <p className="subtitle">{this.props.t("menu2item0")}</p>
          <p></p>
          <p className="note">{this.props.t("avertissement")}</p>
          <p className="tutoList">
          {menuP.map(item => {
            return (
              <ul>
              <NavLink key={item.label} to={item.path}>
                <li key={item.label} className="menuItem">
                  {item.label}
                </li>
              </NavLink>
              </ul>
            );
          })}
          </p>
        </div>)
      }
}

const FadeTransitionRouter = props => {
  return (
    <Location>
      {({ location }) => {
        console.log("Technique location ?", location);
        return (
          <TransitionGroup className="transition-group">
            <CSSTransition key={location.key} classNames="fade" timeout={500}>
              <Router location={location} className="router">
                {props.children}
              </Router>
            </CSSTransition>
          </TransitionGroup>
        );
      }}
    </Location>
  );
};

export default translate(Technique);
